export const standardTooltipProps = {
  placement: 'top' as const,
  arrow: true,
  enterDelay: 1500,
}
